// Draft store for the Add Beneficiary form (see helpers/formDraft). One draft
// per user. Only worth keeping once someone has actually typed something
// about the child; the form's own defaults (status, priority, dates) don't
// count.
import { anyFilled, createDraftStore } from 'helpers/formDraft';

export const beneficiaryDraftStore = createDraftStore({
  prefix: 'beneficiary-draft',
  hasContent: values =>
    anyFilled([
      values?.firstName,
      values?.middleName,
      values?.lastName,
      values?.hyConnectId,
      values?.address,
      values?.inspiration,
      values?.hobbies,
      values?.caseNotes,
      values?.guardian?.firstName,
      values?.guardian?.lastName,
      values?.location?.city
    ])
});

export const clearDraft = userId => beneficiaryDraftStore.clear(userId);
